import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { useContext, useMemo } from 'react';
import { SmartSendContext } from '../../../lib/context/SmartSendContext';
import { ToggleSelectionItemsAction } from '../../../lib/context/SmartSendContextModels';
import { EventSections } from '~/apps/smartsend/lib/events/EventLogger';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

interface props {
  selected: number;
  total: number;
  filterKey: string;
}

const sections = [EventSections.SmartSend, EventSections.QuickSelect];

const QuickToggleAll = (props: props) => {
  const ctx = useContext(SmartSendContext);
  const { track } = useSmartSendAnalytics();
  const isSelected = useMemo(() => props.total > 0 && props.selected === props.total, [props.selected, props.total]);

  const toggleAll = (v: boolean) => {
    track({
      type: 'selection_changed',
      payload: GenerateBaseAnalyticsPayload(sections, {
        surface: 'quick-select',
        action: v ? 'select-all' : 'clear',
        affectedItemCount: props.total,
        value: v
      })
    });
    ctx.dispatch(new ToggleSelectionItemsAction(props.filterKey, 'TOGGLE_ALL', v));
  };

  return (
    <P2GCheckBoxLegacy
      id="QuickSelect"
      onChange={() => toggleAll(!isSelected)}
      checked={isSelected}
      labelPlacement="end"
      variant="primary"
      error={false}
      label={null}
    />
  );
};

export default QuickToggleAll;
